import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_TYPE} from '../../../utils/DropdownOptionPropsUtils';

export const videoFileTypeResource: DropdownOptionProps[] = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'webm', value: 'webm'
    },
    {
        name: 'avi', value: 'avi'
    },
    {
        name: 'x-msvideo', value: 'x-msvideo'
    },
    {
        name: 'mp4', value: 'mp4'
    },
    {
        name: 'mpeg', value: 'mpeg'
    },
    {
        name: 'ogv', value: 'ogv'
    },
    {
        name: 'ts', value: 'ts'
    },
    {
        name: '3gp', value: '3gp'
    },
    {
        name: '3gpp', value: '3gpp'
    },
    {
        name: '3g2', value: '3g2'
    },
    {
        name: '3gpp2', value: '3gpp2'
    }
];